import store from "@frameworks/web/redux/store";
import { PLACE_NORMALTRADE_CLEAR_DATA, PLACE_NORMALTRADE_DATA, PLACE_NORMALTRADE_ERROR_DATA, PLACE_NORMALTRADE_HIDE_ERROR_DATA, PLACE_NORMALTRADE_START_LOADER, PLACE_NORMALTRADE_STOP_LOADER, } from "../interface/IPlaceNormalTrade";
class PlaceNormalTradeActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    placeNormalTrade(placeNormalTrade) {
        this.dispatch({
            type: PLACE_NORMALTRADE_DATA,
            payload: { placeNormalTrade },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: PLACE_NORMALTRADE_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    clearData() {
        this.dispatch({
            type: PLACE_NORMALTRADE_CLEAR_DATA,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: PLACE_NORMALTRADE_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: PLACE_NORMALTRADE_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: PLACE_NORMALTRADE_STOP_LOADER,
        });
    }
}
export default PlaceNormalTradeActions;
